/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Uniqueworkplace_Global1Inputs */

const ja_careers_uniqueworkplace_global1 = /** @type {(inputs: Careers_Uniqueworkplace_Global1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グローバルな環境のゲーム業界`)
};

const en_careers_uniqueworkplace_global1 = /** @type {(inputs: Careers_Uniqueworkplace_Global1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work in the global games industry!`)
};

/**
* | output |
* | --- |
* | "Work in the global games industry!" |
*
* @param {Careers_Uniqueworkplace_Global1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_uniqueworkplace_global1 = /** @type {((inputs?: Careers_Uniqueworkplace_Global1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Uniqueworkplace_Global1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_uniqueworkplace_global1(inputs)
	return en_careers_uniqueworkplace_global1(inputs)
});
export { careers_uniqueworkplace_global1 as "careers_uniqueWorkplace_global" }